import { HttpResponse, HttpStatusEnum } from '@core/api';
import { EstimatedAmount, RequesterUser } from '@shared/interfaces';
import { OrderStatusForRetestEnum } from '../enums';
import { OrderSampleDetails, OrderShort } from '../interfaces';
import { PrepareStep3Interface } from '../interfaces/prepare-step3-data.interface';

export class OrderRetestSetupMapper {
    static mapSearchOrders(data: any): HttpResponse<OrderShort[]> {
        return {
            status: HttpStatusEnum.SUCCESS,
            data: data.map((order: any) => {
                return {
                    id: order.id,
                    compositeName: order.compositeName ?? '-',
                    numberOfReactions: order.numberOfReactions,
                    status: order.status,
                    isDisabled: order.status != OrderStatusForRetestEnum.AVAILABLE,
                };
            }),
        };
    }

    static mapGetOrder(data: any): HttpResponse<{ order: OrderShort | null }> {
        return {
            status: HttpStatusEnum.SUCCESS,
            data: {
                order: data.order
                    ? {
                          id: data.order.id,
                          compositeName: data.order.compositeName ?? '-',
                          numberOfReactions: data.order.numberOfReactions,
                          status: data.order.status,
                          isDisabled: data.order.status != OrderStatusForRetestEnum.AVAILABLE,
                      }
                    : null,
            },
        };
    }

    static mapPrepareStep2Retest(data: any): HttpResponse<OrderSampleDetails> {
        return {
            status: HttpStatusEnum.SUCCESS,
            data: {
                id: data.id,
                compositeName: data.compositeName,
                samples: data.samples.map((sample: any) => {
                    return {
                        sampleName: sample.name,
                        size: sample.size,
                        dnaType: sample.dnaType,
                        barcode: sample.barcode,
                        isHidden: false,
                        isExpanded: false,
                        primers: sample.primers.map((primer: any) => {
                            return {
                                reactionId: primer.reactionId,
                                name: primer.name,
                                status: primer.status,
                                barcode: primer.barcode,
                                sequence: primer.sequence,
                                type: primer.type,
                                isHidden: false,
                                isSelected: false,
                            };
                        }),
                    };
                }),
            },
        };
    }

    static mapPrepareStep3Retest(data: any): HttpResponse<PrepareStep3Interface> {
        return {
            status: HttpStatusEnum.SUCCESS,
            data: {
                requesterId: data.requesterId,
                informedUserIds: data.informedUserIds.map((informedUserId: number) => {
                    return informedUserId;
                }),
                informedUserOptions: data.informedUserOptions.map((informedUser: any) => {
                    return {
                        email: informedUser.email,
                        id: informedUser.id,
                        fullName: `${informedUser.firstName} ${informedUser.lastName}`,
                    };
                }),
                serviceLevels: {
                    hours: data.serviceLevels[0].hours,
                    id: data.serviceLevels[0].id,
                    name: data.serviceLevels[0].name,
                },
                requesters: data.groupUsers.map((user: any): RequesterUser => {
                    return {
                        email: user.email,
                        fullName: `${user.firstName} ${user.lastName}`,
                        id: user.id,
                        lab: user.lab,
                        organization: user.organization,
                    };
                }),
            },
        };
    }

    static mapEstimateAmount(data: any): HttpResponse<EstimatedAmount> {
        return {
            status: HttpStatusEnum.SUCCESS,
            data: {
                reactionsCount: data.orderEstimate.reactionsCount,
                shipping: data.orderEstimate.shipping,
                subtotal: data.orderEstimate.subtotal,
                total: data.orderEstimate.total,
                reactionEstimates: data.orderEstimate.sampleEstimates.map((sample: any) => {
                    return {
                        primerPrice: sample.primerPrice,
                        primersCount: sample.primersCount,
                        total: sample.total,
                        sampleName: sample.name,
                    };
                }),
            },
        };
    }
}
